import script from "./UiModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UiModal.vue?vue&type=script&setup=true&lang=js"

import "./UiModal.vue?vue&type=style&index=0&id=3bfd805a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfd805a"]])

export default __exports__